// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"9fe5ae6a","703":"ba399ea7"}[chunkId] + ".chunk.js";
};